import { render, staticRenderFns } from "./RelatedReviews.vue?vue&type=template&id=18e7db82&scoped=true"
import script from "./RelatedReviews.vue?vue&type=script&lang=js"
export * from "./RelatedReviews.vue?vue&type=script&lang=js"
import style0 from "./RelatedReviews.vue?vue&type=style&index=0&id=18e7db82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e7db82",
  null
  
)

export default component.exports